import React from 'react';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';
import { useSidebar } from '../../../contexts/SidebarContext';

const Layout = ({ children, hideSidebar = false }) => {
  const { isCollapsed } = useSidebar();

  const contentWidth = hideSidebar
    ? '!ml-0 !w-full'
    : isCollapsed
      ? 'ml-[50px] w-[calc(100%-50px)]'
      : 'ml-[190px] w-[calc(100%-190px)]';

  return (
    <div className="learner-layout flex min-h-screen bg-[var(--bg-primary)] transition-colors duration-300 max-md:min-h-screen max-md:h-auto max-md:overflow-visible max-md:w-full max-md:max-w-full max-md:m-0 max-md:p-0">
      <Navbar />
      {!hideSidebar && <Sidebar />}
      <div
        className={`learner-content flex-1 min-h-screen p-0 transition-all duration-[400ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${contentWidth} max-md:!ml-0 max-md:!w-full max-md:!max-w-full max-md:!p-0 max-md:!pb-[50px] max-md:overflow-visible max-md:min-h-auto max-md:h-auto`}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;

